import { configureStore } from '@reduxjs/toolkit'
import onboardingDetailSlice from './onboardingReducer';
import paymentSlice from './stripeReducer';
import userReducer from './userReducer'
import unseenMessagesReducer from './chatReducer';
export default configureStore({
  reducer: {
    onboardingDetails: onboardingDetailSlice.reducer,
    stripeDetails : paymentSlice.reducer,
    user: userReducer.reducer,
    unseenMessages: unseenMessagesReducer.reducer,
  },
})